import React, { useEffect, useState } from "react";

import Header from "../components/Header";
import * as XLSX from "xlsx";
import axios from "axios";
import stringToColor from "../services/stringToColor";
import { tokens } from "../theme";
import {
  Box,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Avatar,
  IconButton,
  InputAdornment,
  Divider,
  Chip,
  Checkbox,
  useTheme,
  Tabs,
  Tab,
  Snackbar,
  Alert,
  LinearProgress,
  Paper,
  FormControl,
  FormLabel,
  FormGroup,
  Drawer,
  CircularProgress,
  InputLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  Send,
  WhatsApp,
  Email,
  Search,
  Cancel,
  CloudUpload,
  CloudDownload,
  ContentCopy,
  CheckBoxRounded,
  CancelRounded,
  CheckRounded,
  NotificationsSharp,
  CheckCircle,
  Check,
  Warning,
  AccountCircle,
  Phone,
  SmsRounded,
  SendSharp,
  Settings,
  ResetTvSharp,
  Delete,
  LocationCity,
  LocationPin,
  Home,
  Stairs,
  MonetizationOn,
  CalendarMonth,
  DeleteOutline,
  Apartment,
  HolidayVillage,
  Numbers,
  SettingsVoiceOutlined,
  InsertDriveFile,
  ViewAgenda,
  ViewCarousel,
  ViewArray,
  RemoveRedEye,
} from "@mui/icons-material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { DataGrid } from "@mui/x-data-grid";
import AssignPropertyDialog from "../components/AssignPropertyDialog";
import ResetPasswordDialog from "../components/ResetPasswordDialog";
import { useUser } from "../provider/AuthProvider";
import ConfirmDialog from "../components/ComfirmationDialog";
import BreadcrumbsBar from "../components/BreadcrumbsBar";
import UserAddDialog from "../components/UserAddDialog";
import CSVImportDialog from "../components/CSVImportDialog";
import { useNavigate, useSearchParams } from "react-router-dom";
import AssignLandlordPropertiesDialog from "../components/AssignLandlordPropertiesDialog";
import { useTranslation } from "react-i18next";

const chartData = [
  { name: "Verified", value: 70 },
  { name: "Pending", value: 30 },
];

const COLORS = ["#0088FE", "#FF8042"];

const TenantLandlordPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const [userType, setUserType] = useState("Tenant");
  const [userList, setUserList] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openNotifyDialog, setOpenNotifyDialog] = useState(false);
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const { user } = useUser();
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [assignLandlordDialogOpen, setAssignLandlordDialogOpen] =
    useState(false);
  const [isLoading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [csvDialogOpen, setCsvDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const navigate = useNavigate();
  const [editedFields, setEditedFields] = useState({
    username: "",
    email: "",
    phone: "",
  });

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [searchParams] = useSearchParams();
  const focusId = searchParams.get("focusId");

  useEffect(() => {
    if (focusId && userList.length > 0) {
      // Find the user and open their details
      const tenant = userList.find(
        (u) =>
          String(u.id) === String(focusId) ||
          String(u.user_id) === String(focusId)
      );
      if (tenant) {
        handleManage(tenant); // Your drawer logic
        setUserType("Tenant");
        // Optionally, scroll to or highlight the tenant in the DataGrid
      }
    }
    // eslint-disable-next-line
  }, [userList, focusId]);

  useEffect(() => {
    fetchUsers();
    setCurrentUser(null); // 👈 reset selected user
    setSelectedUserIds([]);
  }, [userType]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/cmt/${
        userType === "Tenant" ? "getTenants" : "getLandlords"
      }/${user.id}`;
      const res = await axios.get(url);

      setUserList(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setLoading(false);
    }
  };
  const handleSelectionChange = (ids) => {
    const selectedUsers = userList.filter((user) => ids.includes(user.id));
    const userIds = selectedUsers.map((user) => user.user_id);
    console.log("Selected user IDs:", userIds);
    setSelectedUserIds(userIds);
  };
  const filteredUsers = userList.filter(
    (u) =>
      u.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.phone.includes(searchTerm)
  );
  const hasChanges = () => {
    return (
      currentUser &&
      (currentUser.username !== editedFields.username ||
        currentUser.email !== editedFields.email ||
        currentUser.phone !== editedFields.phone)
    );
  };

  function extractS3KeyFromUrl(url) {
    const urlObj = new URL(url);
    return decodeURIComponent(urlObj.pathname.substring(1));
  }

  async function downloadDocument(s3Url) {
    try {
      const s3Key = extractS3KeyFromUrl(s3Url);
      console.log(s3Key);
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/upload/getDownloadURL?key=${s3Key}`
      );
      const { url } = await res.json();
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", ""); // Optional, presigned URL already sets correct name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Download failed");
    }
  }

  const handleSaveUser = async () => {
    setIsSaving(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/updateUser/${currentUser.user_id}`,
        {
          username: editedFields.username,
          email: editedFields.email,
          phone: editedFields.phone,
        }
      );
      const updatePayload = {};
      if (editedFields.username) updatePayload.username = editedFields.username;
      if (editedFields.email) updatePayload.email = editedFields.email;
      if (editedFields.phone) updatePayload.phone = editedFields.phone;
      setCurrentUser((prev) => ({
        ...prev,
        ...updatePayload,
      }));
      setSnack({
        open: true,
        message: t("tenant_page.user_updated"),
        severity: "success",
      });
      fetchUsers(); // refresh list
    } catch (err) {
      setSnack({
        open: true,
        message: t("tenant_page.user_update_failed"),
        severity: "error",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleManage = async (user) => {
    setCurrentUser(user);
    console.log(userList.find((u) => u.id === user.id));
    setEditedFields({
      username: user.username || "",
      email: user.email || "",
      phone: user.phone || "",
    });

    setDrawerOpen(true);
  };
  const handleResetClick = async (user) => {
    setCurrentUser(user);
    setResetDialogOpen(true);
  };
  const handleDeleteClick = async (user) => {
    setCurrentUser(user);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      setIsDeleting(true);
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/cmt/deleteUser/${currentUser.user_id}`
      );
      setUserList((prev) => prev.filter((u) => u.id !== currentUser.id));
      setSnack({ open: true, message: t("tenant_page.user_deleted"), severity: "success" });
    } catch {
      setSnack({ open: true, message: t("tenant_page.delete_failed"), severity: "error" });
    } finally {
      setDeleteDialogOpen(false);
      setCurrentUser(null);
      setIsDeleting(false);
    }
  };
  const handleStatusChange = async (status) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cmt/userActive`,
        {
          id: currentUser.user_id,
          user_id: user.id,
          status,
        }
      );
      setCurrentUser((prev) => ({ ...prev, status }));
      setSnack({
        open: true,
        message: t("tenant_page.provider_status_changed", { status }),
        severity: "success",
      });
    } catch {
      setSnack({
        open: true,
        message: t("tenant_page.provider_status_change_failed"),
        severity: "error",
      });
    } finally {
      setLoading(false);
      fetchUsers();
    }
  };

  const handleBulkStatusChange = async (status) => {
    setLoading(true);
    try {
      console.log(selectedUserIds);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cmt/userBulkActive`,
        {
          userIds: selectedUserIds, // <-- pass array of selected user IDs
          status,
        }
      );

      setSnack({
        open: true,
        message: t("tenant_page.bulk_status_updated", { count: selectedUserIds.length, status }),
        severity: "success",
      });
    } catch (error) {
      console.error("Bulk status change error:", error);
      setSnack({
        open: true,
        message: t("tenant_page.bulk_status_failed"),
        severity: "error",
      });
    } finally {
      setLoading(false);
      fetchUsers(); // Refresh user list
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    try {
      console.log(selectedUserIds);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cmt/userBulkDelete`,
        {
          userIds: selectedUserIds,
        }
      );

      setSnack({
        open: true,
        message: t("tenant_page.bulk_deleted", { count: selectedUserIds.length }),
        severity: "success",
      });
    } catch (error) {
      console.error("Bulk status change error:", error);
      setSnack({
        open: true,
        message: t("tenant_page.bulk_delete_failed"),
        severity: "error",
      });
    } finally {
      setLoading(false);
      fetchUsers(); // Refresh user list
    }
  };

  const handlePasswordReset = async (newPassword) => {
    try {
      setSnack({
        open: true,
        message: t("tenant_page.password_changed"),
        severity: "success",
      });
      // const res = await fetch(
      //   `${process.env.REACT_APP_BACKEND_URL}/api/admin/CMTResetPassword/${selectedUser.id}`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({ password: newPassword }),
      //   }
      // );
      // if (res.ok) {

      //   setResetDialogOpen(false);
      // } else {
      //   console.error("Failed to reset password");
      // }
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };
  const handleSendNotify = async () => {
    console.log(selectedUserIds);
    try {
      setSubmit(true);

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/create`,
        {
          title: messageTitle,
          message: messageBody,
          type: "GENERAL",
          send_type: "immediate",
          schedule_at: null,
          to_user_ids: selectedUserIds,
          from_user_id: user.id,
        }
      );

      setSnack({
        open: true,
        message: t("tenant_page.notification_sent"),
        severity: "success",
      });
    } catch (error) {
      setSnack({
        open: true,
        message: t("tenant_page.notification_failed"),
        severity: "error",
      });
    } finally {
      setSubmit(false);
      setOpenNotifyDialog(false);
    }
  };
  const handleAddUser = async (newUser) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/createUser`,
        {
          ...newUser,
        }
      );
      setSnack({
        open: true,
        message: t("tenant_page.user_created"),
        severity: "success",
      });
      setAddUserOpen(false);
      fetchUsers();
    } catch (err) {
      console.error(err);
      setSnack({
        open: true,
        message: t("tenant_page.user_create_failed"),
        severity: "error",
      });
    }
  };

  // const handleExportCSV = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(userList);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  //   XLSX.writeFile(workbook, `${userType}_List.xlsx`);
  // };

  const handleDownloadTemplate = () => {
    const headersAndExamples = [
      ["username", "email", "phone", "password", "role"], // header
      ["john_doe", "john@example.com", "+1234567890", "Password123!", "TENANT"],
      [
        "jane_land",
        "jane@landlord.com",
        "+0987654321",
        "SecurePass456!",
        "LANDLORD",
      ],
      [
        "plumb_master",
        "plumb@example.com",
        "+1122334455",
        "PipeFix789!",
        "SERVICE_PROVIDER",
      ],
    ];
    const ws = XLSX.utils.aoa_to_sheet(headersAndExamples);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    XLSX.writeFile(wb, "user_template.csv");
  };

  const handleImportCSV = async (event) => {};

  const tenantColumn = [
    {
      field: "avatar",
      headerName: "",
      renderCell: (params) => {
        const name = params?.row?.fullname || "U";
        const avatarUrl = params?.row?.avatar_url;

        return avatarUrl ? (
          <Avatar alt={name} src={avatarUrl} className="notranslate" />
        ) : (
          <Avatar sx={{ bgcolor: stringToColor(name) }} className="notranslate">
            {name.charAt(0).toUpperCase()}
          </Avatar>
        );
      },
      flex: 0.5,
    },
    {
      field: "username",
      headerName: t("tenant_page.col_name"),
      flex: 0.5,
      renderCell: (params) => (
        <Typography className="notranslate">{params?.value}</Typography>
      ),
    },
    { field: "email", headerName: t("tenant_page.col_email"), flex: 0.5 },
    {
      field: "phone",
      headerName: t("tenant_page.col_phone"),
      flex: 0.5,
      renderCell: (params) => (
        <Typography className="notranslate" dir="ltr">
          {params?.value}
        </Typography>
      ),
    },
    {
      field: "status",
      headerName: t("tenant_page.col_status"),
      renderCell: (params) => {
        const status = params?.row?.status;
        return status == "pending" ? (
          <Chip label={status?.toUpperCase()} color="info" />
        ) : status == "active" ? (
          <Chip label={status?.toUpperCase()} color="success" />
        ) : (
          <Chip label={status?.toUpperCase()} color="error" />
        );
      },
    },
    {
      field: "assigned_property",
      headerName: t("tenant_page.col_assigned_property"),
      flex: 1,
      renderCell: (params) => {
        const unit = params?.row?.unit_name;
        if (!unit) return <Typography>-</Typography>;
        return <Chip label={unit || ""} color="info" className="notranslate" />;
      },
    },
    {
      field: "actions",
      headerName: t("tenant_page.col_actions"),
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
            color="primary"
            onClick={(e) => {
              e.stopPropagation(); // ✅ Prevents row selection
              handleManage(params.row);
            }}
          >
            <Settings />
          </IconButton>
          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation(); // ✅ Prevents row selection
              handleDeleteClick(params.row);
            }}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];
  const landlordColumn = [
    {
      field: "avatar",
      headerName: "",
      renderCell: (params) => {
        const name = params?.row?.fullname || "U";
        const avatarUrl = params?.row?.avatar_url;

        return avatarUrl ? (
          <Avatar alt={name} src={avatarUrl} className="notranslate" />
        ) : (
          <Avatar sx={{ bgcolor: stringToColor(name) }} className="notranslate">
            {name.charAt(0).toUpperCase()}
          </Avatar>
        );
      },
      flex: 0.5,
    },
    {
      field: "username",
      headerName: t("tenant_page.col_name"),
      flex: 0.5,
      renderCell: (params) => (
        <Typography className="notranslate">{params?.value}</Typography>
      ),
    },
    {
      field: "email",
      headerName: t("tenant_page.col_email"),
      flex: 0.5,
      renderCell: (params) => (
        <Typography className="notranslate">{params?.value}</Typography>
      ),
    },
    {
      field: "phone",
      headerName: t("tenant_page.col_phone"),
      flex: 0.5,
      renderCell: (params) => (
        <Typography className="notranslate" dir="ltr">
          {params?.value}
        </Typography>
      ),
    },
    {
      field: "status",
      headerName: t("tenant_page.col_status"),
      renderCell: (params) => {
        const status = params?.row?.status;
        return status == "pending" ? (
          <Chip label={status?.toUpperCase()} color="info" />
        ) : status == "active" ? (
          <Chip label={status?.toUpperCase()} color="success" />
        ) : (
          <Chip label={status?.toUpperCase()} color="error" />
        );
      },
    },
    {
      field: "actions",
      headerName: t("tenant_page.col_actions"),
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
            color="primary"
            onClick={(e) => {
              e.stopPropagation(); // ✅ Prevents row selection
              handleManage(params.row);
            }}
          >
            <Settings />
          </IconButton>
          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation(); // ✅ Prevents row selection
              handleDeleteClick(params.row);
            }}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box className="main-container mt-4">
      <BreadcrumbsBar />
      <Box display="flex" justifyContent="space-around">
        <Grid
          container
          spacing={2}
          columns={{ xs: 2, sm: 8, md: 10 }}
          rows={{ xs: 3, sm: 1, md: 1 }}
          sx={{
            width: "100%",
          }}
        >
          <Grid item size={{ xs: 2, sm: 2, md: 2 }}>
            <Paper
              sx={{
                padding: 2,
                height: "85vh",
              }}
              elevation={3}
            >
              <FormControl
                component="fieldset"
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  display: "flex",
                  m: 1,
                  p: 1, // padding inside border
                }}
              >
                <FormLabel component="legend">{t("tenant_page.user_type")}</FormLabel>
                <RadioGroup
                  value={userType}
                  onChange={(e) => setUserType(e.target.value)}
                >
                  <FormControlLabel
                    value="Tenant"
                    control={<Radio />}
                    label={t("tenant_page.tenant")}
                  />
                  <FormControlLabel
                    value="Landlord"
                    control={<Radio />}
                    label={t("tenant_page.landlord")}
                  />
                </RadioGroup>
              </FormControl>
              <FormControl
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  // width: "",
                  display: "flex",
                  p: 1,
                  m: 1, // padding inside border
                }}
              >
                <FormLabel component="legend">{t("tenant_page.csv_management")}</FormLabel>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<CloudUpload />}
                  sx={{ mt: 0.5 }}
                  onClick={() => setCsvDialogOpen(true)}
                >
                  {t("tenant_page.import")}
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<CloudDownload />}
                  sx={{ mt: 0.5 }}
                  onClick={handleDownloadTemplate}
                >
                  {t("tenant_page.download_template")}
                </Button>
              </FormControl>
              <FormControl
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  // width: "",
                  display: "flex",
                  p: 1,
                  m: 1, // padding inside border
                }}
              >
                <FormLabel component="legend">{t("tenant_page.bulk_action")}</FormLabel>

                <Button
                  variant="contained"
                  color="success"
                  startIcon={<CheckCircle />}
                  onClick={() => handleBulkStatusChange("active")}
                  sx={{ color: "#fff", mt: 1 }}
                  disabled={selectedUserIds.length == 0 ? true : false}
                >
                  {t("tenant_page.active")}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Cancel />}
                  onClick={() => handleBulkStatusChange("inactive")}
                  sx={{ color: "#fff", mt: 1 }}
                  disabled={selectedUserIds.length == 0 ? true : false}
                >
                  {t("tenant_page.inactive")}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Delete />}
                  onClick={() => handleBulkDelete()}
                  sx={{ color: "#fff", mt: 3 }}
                  disabled={selectedUserIds.length == 0 ? true : false}
                >
                  {t("tenant_page.delete")}
                </Button>
                {/* <Button
                  variant="outlined"
                  startIcon={<SendSharp />}
                  sx={{ mt: 3 }}
                  disabled={selectedUserIds.length == 0 ? true : false}
                  onClick={() => setOpenNotifyDialog(true)}
                >
                  Send Message
                </Button> */}
                <Typography>
                  {t("tenant_page.selected_count", { count: selectedUserIds.length })}
                </Typography>
              </FormControl>
            </Paper>
          </Grid>

          <Grid item size={{ xs: 2, sm: 6, md: 8 }}>
            <Paper
              sx={{
                padding: 2,
                height: "85vh",
              }}
              elevation={3}
            >
              <Grid
                container
                spacing={4}
                columns={{ xs: 2, sm: 8, md: 10 }}
                display="flex"
                justifyContent="space-between"
              >
                <Grid item columns={{ xs: 2, sm: 4, md: 5 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t("tenant_page.search_placeholder")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setSearchTerm("")}>
                            <Cancel />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item columns={{ xs: 2, sm: 2, md: 3 }}>
                  <Button
                    color="info"
                    variant="contained"
                    onClick={() => setAddUserOpen(true)}
                    sx={{ color: "#fff" }}
                  >
                    {t("tenant_page.add")}
                  </Button>
                </Grid>
              </Grid>
              <Box sx={{ height: "90%" }}>
                <DataGrid
                  rows={filteredUsers}
                  columns={userType == "Tenant" ? tenantColumn : landlordColumn}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10]}
                  // onRowClick={handleRowClick}
                  getRowId={(row) => row.id}
                  sx={{
                    borderRadius: 2,
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "rgba(255,255,255,0.06)"
                          : "#f5f5f5",
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#003f5c" : "#e0f7fa",
                    },
                    "& .MuiDataGrid-cell": {
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                    },
                  }}
                  checkboxSelection
                  selectionModel={selectedUserIds ? [selectedUserIds] : []}
                  onRowSelectionModelChange={(ids) =>
                    handleSelectionChange(ids)
                  }
                  components={{
                    NoRowsOverlay: () => (
                      <Box
                        height="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography variant="body2" color="text.secondary">
                          {t("tenant_page.no_users_found")}
                        </Typography>
                      </Box>
                    ),
                  }}
                  loading={isLoading}
                >
                  {isLoading && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                        bgcolor: "rgba(255,255,255,0.7)",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
                </DataGrid>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        {/* Drawer for user details */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
            navigate(".", { replace: true });
          }}
        >
          <Box
            sx={{
              width: 400,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {currentUser?.avatar_url ? (
              <Avatar
                className="notranslate"
                sx={{ width: 80, height: 80, mb: 2 }}
                alt={currentUser?.username}
                src={currentUser?.avatar_url}
              />
            ) : (
              <Avatar
                className="notranslate"
                sx={{
                  width: 80,
                  height: 80,
                  mb: 2,
                  bgcolor: stringToColor(currentUser?.fullname),
                }}
              >
                <Typography variant="h1" className="notranslate">
                  {currentUser?.fullname.charAt(0).toUpperCase()}
                </Typography>
              </Avatar>
            )}
            <Typography variant="h6" gutterBottom className="notranslate">
              {currentUser?.fullname}
            </Typography>
            <Box display="flex" justifyContent="center" gap={2}>
              <Chip
                icon={
                  currentUser?.status === "active" ? (
                    <CheckCircle />
                  ) : (
                    <Cancel />
                  )
                }
                label={currentUser?.status.toUpperCase()}
                color={
                  currentUser?.status === "active"
                    ? "success"
                    : currentUser?.status === "pending"
                    ? "primary"
                    : "error"
                }
                size="small"
              />
              <Chip
                icon={currentUser?.verified ? <Check /> : <Cancel />}
                label={currentUser?.verified ? t("tenant_page.verified") : t("tenant_page.non_verified")}
                color={currentUser?.verified ? "success" : "default"}
                size="small"
              />
            </Box>

            <Box width="100%" mt={2}>
              <TextField
                label={t("tenant_page.username")}
                value={editedFields.username}
                onChange={(e) => {
                  setEditedFields((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }));
                }}
                margin="normal"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label={t("tenant_page.email")}
                value={editedFields.email}
                onChange={(e) => {
                  setEditedFields((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }));
                }}
                margin="normal"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label={t("tenant_page.phone")}
                value={editedFields.phone}
                onChange={(e) => {
                  setEditedFields((prev) => ({
                    ...prev,
                    phone: e.target.value,
                  }));
                }}
                margin="normal"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone />
                    </InputAdornment>
                  ),
                }}
                dir="ltr"
              />
              {/* <TextField
                label="Communication Method"
                defaultValue={
                  currentUser?.communication_method === "both"
                    ? "WhatsApp, Email"
                    : currentUser?.communication_method
                }
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SmsRounded />
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Box>
            {userType === "Landlord" && (
              <FormControl
                fullWidth
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  // width: "",
                  display: "flex",
                  p: 1,
                  m: 1, // padding inside border
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <FormLabel sx={{ flex: 1 }}>{t("assigned_properties")}</FormLabel>
                  {currentUser?.Unit && currentUser.Unit.length > 0 && (
                    <IconButton
                      onClick={() => setAssignLandlordDialogOpen(true)}
                    >
                      <Settings />
                    </IconButton>
                  )}
                </Box>
                <Box sx={{ mb: 1 }}>
                  {currentUser?.Unit && currentUser.Unit.length > 0 ? (
                    <List dense>
                      {currentUser.Unit.map((p) => (
                        <ListItem
                          className="notranslate"
                          key={p.id}
                          disablePadding
                          sx={{
                            px: 1.5,
                            borderRadius: 1,
                            cursor: "pointer",
                            transition: "background 0.2s",
                            "&:hover": {
                              background: "#1976d222", // Light blue, adjust as needed
                            },
                          }}
                        >
                          <ListItemText
                            className="notranslate"
                            primary={`${p.unit_name} (${p.building_name})`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      {t("tenant_page.no_properties_assigned")}
                    </Typography>
                  )}
                </Box>
                {/* Show "Assign Properties" button only if NO properties */}
                {(!currentUser?.Unit || currentUser.Unit.length === 0) && (
                  <Button
                    variant="outlined"
                    sx={{ mt: 2 }}
                    onClick={() => setAssignLandlordDialogOpen(true)}
                    className="notranslate"
                  >
                    {t("assign_properties")}
                  </Button>
                )}
              </FormControl>
            )}

            <AssignLandlordPropertiesDialog
              open={assignLandlordDialogOpen}
              onClose={() => setAssignLandlordDialogOpen(false)}
              landlord={currentUser}
              onAssigned={() => {
                setAssignLandlordDialogOpen(false);
                setDrawerOpen(false);
                setCurrentUser(null);
                fetchUsers();
              }}
            />

            {userType == "Tenant" && (
              <>
                <FormControl
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    // width: "",
                    display: "flex",
                    p: 1,
                    m: 1, // padding inside border
                  }}
                  fullWidth
                >
                  <FormLabel>{t("tenant_page.property_information")}</FormLabel>
                  {currentUser?.propertyStatus == "unrented" ? (
                    <>
                      <Box display="flex" justifyItems="center" gap={2}>
                        <Warning color="warning" />
                        <Typography
                          color="warning"
                          sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                          {t("tenant_page.unit_not_assigned")}
                        </Typography>
                      </Box>
                      <Button
                        variant="outlined"
                        sx={{ mt: 2 }}
                        onClick={() => setAssignDialogOpen(true)}
                      >
                        {t("tenant_page.assign_property")}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Box
                        display="flex"
                        gap={1}
                        alignItems="center"
                        className="notranslate"
                      >
                        {currentUser?.unit_type?.toUpperCase() == "TOWER" ? (
                          <LocationCity />
                        ) : (
                          <HolidayVillage />
                        )}
                        <Typography variant="h5">
                          {`${currentUser?.unit_name}` || "N/A"}
                        </Typography>
                        <Typography variant="h6">
                          {`( ${currentUser?.building_name} )` || "_"}
                        </Typography>
                      </Box>

                      {/* <Box display="flex" gap={1} alignItems="center">
                      <LocationPin />
                      <Typography variant="body2">
                        {currentUser?.address || "N/A"}
                      </Typography>
                    </Box>
                    <Box display="flex" gap={1} alignItems="center">
                      <Numbers />
                      {currentUser?.unit_type.toLowerCase() == "tower" ? (
                        <Typography variant="body2">
                          Floor {currentUser?.floor}, &nbsp; Flat{" "}
                          {currentUser?.flat_number}
                        </Typography>
                      ) : (
                        <Typography variant="body2">
                          Block {currentUser?.floor}, &nbsp; Villa{" "}
                          {currentUser?.flat_number}
                        </Typography>
                      )}
                    </Box>
                    {currentUser?.rent_amount && (
                      <Box display="flex" gap={1} alignItems="center">
                        <MonetizationOn />
                        <Typography variant="body2">
                          {currentUser?.rent_amount || "N/A"}
                        </Typography>
                      </Box>
                    )}
                    {(currentUser?.lease_end || currentUser?.lease_start) && (
                      <Box display="flex" gap={1} alignItems="center">
                        <CalendarMonth />
                        <Typography
                          variant="body2"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {new Date(currentUser?.lease_start).toDateString() ||
                            "N/A"}
                          {" ~ "}
                          {new Date(currentUser?.lease_end).toDateString() ||
                            "N/A"}
                        </Typography>
                      </Box>
                    )} */}
                      <Button
                        variant="outlined"
                        sx={{ mt: 2 }}
                        onClick={() => setAssignDialogOpen(true)}
                      >
                        {t("tenant_page.reassign_property")}
                      </Button>
                    </>
                  )}
                </FormControl>
                <FormControl
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    display: "flex",
                    p: 1,
                    m: 1,
                  }}
                  fullWidth
                >
                  <FormLabel>{t("tenant_page.uploaded_documents")}</FormLabel>
                  {currentUser?.document?.length > 0 ? (
                    <List dense>
                      {currentUser.document.map((doc, idx) => (
                        <ListItem
                          key={doc.id}
                          sx={{
                            px: 1.5,
                            borderRadius: 1,
                            cursor: "pointer",
                            transition: "background 0.2s",
                            "&:hover": {
                              background:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.06)"
                                  : "#f5f5f5",
                            },
                            alignItems: "center",
                          }}
                          onClick={() => {
                            const fileUrl = encodeURIComponent(
                              doc.document_url
                            );
                            const viewerUrl = `https://docs.google.com/gview?url=${fileUrl}&embedded=true`;
                            window.open(viewerUrl, "_blank");
                          }}
                          secondaryAction={
                            <Box>
                              <IconButton
                                edge="end"
                                color="info"
                                href={doc.document_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="View"
                              >
                                <RemoveRedEye />
                              </IconButton>
                              <IconButton
                                edge="end"
                                color="primary"
                                title="Download"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadDocument(doc.document_url);
                                }}
                              >
                                <CloudDownload />
                              </IconButton>
                              {/* <IconButton
                                edge="end"
                                color="primary"
                                title="Download"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent parent click
                                  handleDocumentDownload(doc.document_url);
                                }}
                              >
                                <CloudDownload />
                              </IconButton> */}
                            </Box>
                          }
                        >
                          <Avatar
                            sx={{
                              bgcolor: "#e0e0e0",
                              width: 32,
                              height: 32,
                              mr: 1,
                              color: "#1976d2",
                              fontSize: 16,
                            }}
                            variant="rounded"
                          >
                            <InsertDriveFile />
                          </Avatar>
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 500,
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  maxWidth: 170,
                                  whiteSpace: "nowrap",
                                }}
                                className="notranslate"
                              >
                                {decodeURIComponent(
                                  doc.document_url.split("/").pop()
                                )}
                              </Typography>
                            }
                            secondary={
                              doc.createdAt
                                ? new Date(doc.createdAt).toLocaleDateString()
                                : ""
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      {t("tenant_page.no_documents_uploaded")}
                    </Typography>
                  )}
                </FormControl>
              </>
            )}

            <Box display="flex" justifyContent="center" gap={2} mt={4}>
              <IconButton disabled={true}>
                <NotificationsSharp />
              </IconButton>
              <IconButton
                variant="outlined"
                disabled={true}
                startIcon={<WhatsApp />}
                color="success"
              >
                <WhatsApp />
              </IconButton>
              <IconButton variant="outlined" disabled={true}>
                <Email />
              </IconButton>
            </Box>
            <Box mt={2}>
              <Divider />
              {!currentUser?.verified && (
                <Box display="flex" alignItems="center" mt={2}>
                  <Warning color="warning" sx={{ mr: 1 }} />
                  <Typography variant="body2" flexGrow={1} color="warning">
                    {t("tenant_page.user_not_verified")}
                  </Typography>
                  {/* <IconButton>
                    <Send />
                  </IconButton> */}
                </Box>
              )}

              <Box display="flex" justifyContent="center" mt={2} gap={2}>
                {currentUser?.status === "pending" && (
                  <>
                    <Button
                      color="success"
                      variant="contained"
                      onClick={() => handleStatusChange("active")}
                      sx={{ color: "#fff" }}
                    >
                      {t("tenant_page.btn_active")}
                    </Button>
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => handleStatusChange("inactive")}
                      sx={{ color: "#fff" }}
                    >
                      {t("tenant_page.btn_inactive")}
                    </Button>
                  </>
                )}
                {currentUser?.status === "active" && (
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => handleStatusChange("inactive")}
                    sx={{ color: "#fff" }}
                  >
                    INACTIVE
                  </Button>
                )}
                {currentUser?.status === "inactive" && (
                  <Button
                    color="success"
                    variant="contained"
                    onClick={() => handleStatusChange("active")}
                    sx={{ color: "#fff" }}
                  >
                    ACTIVE
                  </Button>
                )}
                <Button
                  color="info"
                  variant="contained"
                  onClick={handleSaveUser}
                  disabled={!hasChanges() || isSaving}
                  sx={{ color: "#fff" }}
                >
                  {isSaving ? t("tenant_page.saving") : t("tenant_page.save")}
                </Button>
              </Box>
            </Box>
          </Box>
        </Drawer>

        {/* Reset password dialog */}
        <Dialog
          open={resetDialogOpen}
          onClose={() => setResetDialogOpen(false)}
        >
          <DialogTitle>{t("tenant_page.reset_password")}</DialogTitle>
          <DialogContent>
            <Typography>
              {t("tenant_page.send_reset_link_to")} {currentUser?.email}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setResetDialogOpen(false)}>{t("tenant_page.cancel")}</Button>
            <Button
              variant="contained"
              onClick={() => {
                setSnack({
                  open: true,
                  message: t("tenant_page.reset_email_sent"),
                  severity: "info",
                });
                setResetDialogOpen(false);
              }}
            >
              {t("tenant_page.send_reset")}
            </Button>
          </DialogActions>
        </Dialog>

        <CSVImportDialog
          open={csvDialogOpen}
          onClose={() => setCsvDialogOpen(false)}
          onImported={() => {
            // setCsvDialogOpen(false);
            fetchUsers(); // Refresh user list after import
          }}
        />

        <ResetPasswordDialog
          open={resetDialogOpen}
          onClose={() => setResetDialogOpen(false)}
          onReset={handlePasswordReset}
        />
        <AssignPropertyDialog
          open={assignDialogOpen}
          onClose={() => {
            setAssignDialogOpen(false);
            setDrawerOpen(false);
            setCurrentUser(null);
            fetchUsers();
          }}
          tenant={currentUser}
        />
        <ConfirmDialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onConfirm={confirmDelete}
          title={t("tenant_page.confirm_deletion")}
          content={t("tenant_page.confirm_delete_msg", { username: currentUser?.username })}
          loading={isDeleting}
        />
        {/* <Dialog
          open={openNotifyDialog}
          onClose={() => setOpenNotifyDialog(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Send Message</DialogTitle>
          <DialogContent>
            <Box mt={2}>
              <TextField
                fullWidth
                label="Title"
                variant="outlined"
                sx={{ mb: 2 }}
                value={messageTitle}
                onChange={(e) => setMessageTitle(e.target.value)}
              />
              <TextField
                fullWidth
                label="Message Body"
                variant="outlined"
                multiline
                rows={4}
                value={messageBody}
                onChange={(e) => setMessageBody(e.target.value)}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNotifyDialog(false)}>Cancel</Button>
            <Button variant="contained" onClick={() => handleSendNotify()}>
              {submit ? "Sending..." : "Send"}
            </Button>
          </DialogActions>
        </Dialog> */}
        {/* Snackbar for notifications */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setSnack({ ...snack, open: false })}
        >
          <Alert severity={snack.severity}>{snack.message}</Alert>
        </Snackbar>
      </Box>
      <UserAddDialog
        open={addUserOpen}
        onClose={() => setAddUserOpen(false)}
        onAdd={handleAddUser}
        user_type={userType.toUpperCase()}
      />
    </Box>
  );
};

export default TenantLandlordPage;
